import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeEnIn from '@angular/common/locales/en-IN';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DyanamicFieldsFormModule } from './dyanamic-fields-form/dyanamic-fields-form.module';
import { MaterialModule } from './material/material.module';
import { HttpInterceptors } from './shared/http-interceptors/http-interceptors';
import { AlertService } from './shared/services/alert.service';
import { BackendService } from './shared/services/backend.service';
import { ErrorsHandler } from './shared/services/error-handler.service';
import { GeoService } from './shared/services/geo.service';
import { LoggerService } from './shared/services/logger.service';
import { SecuredStorageProviderService } from './shared/services/secured-storage-provider.service';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localeEnIn);

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MaterialModule,
    ReactiveFormsModule,
    DyanamicFieldsFormModule
  ],
  providers: [
    AlertService,
    BackendService,
    ErrorsHandler,
    LoggerService,
    GeoService,
    SecuredStorageProviderService,
    BnNgIdleService,
    { provide: ErrorHandler, useClass: ErrorsHandler },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptors, multi: true },
    { provide: LOCALE_ID, useValue: 'en-IN' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
